import styled from "styled-components";
import Colors from "assets/Colors.js";

const Wrapper = styled.div`
  background: ${Colors.background_secondary};
  border-radius: 6px;
  max-width: 100vw;
`;

const WrapperBottomComponents = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const DataSelector = styled.div`
  height: 40px;
  box-sizing: border-box;
  display: flex;
  background: ${Colors.background_secondary};
  margin-bottom: 17px;
  margin-right: 13px;
  pointer-events: ${(props) => (props.loadingdata ? "none" : "auto")};
  background-color: ${(props) => props.loadingdata && "#f5f5f5"};
`;

const DateSelectorItem = styled.div`
  padding-left: 19px;
  padding-right: 19px;
  width: 90px;
  color: ${(props) =>
    props.selected ? Colors.text_on_primary : Colors.text_primary};
  background: ${(props) => (props.selected ? Colors.primary_web : "none")};
  display: grid;
  place-content: center;
  cursor: pointer;
  ${(props) =>
    props.selected
      ? ""
      : `border-top: 0.5px solid ${Colors.text_secondary}; 
    border-bottom: 0.5px solid ${Colors.text_secondary};
    border-right: 0.5px solid ${Colors.text_secondary};
    `}
  ${(props) =>
    props.left && !props.selected
      ? `
 border-left: 0.5px solid ${Colors.text_secondary};
 `
      : ""}
${(props) =>
    props.nextSelected
      ? `
      border-right: none;
 `
      : ""}
`;

export default {
  Wrapper,
  DataSelector,
  DateSelectorItem,
  WrapperBottomComponents,
};
